import { render } from "./StepDetails.vue?vue&type=template&id=678f84e0&scoped=true"
import script from "./StepDetails.vue?vue&type=script&lang=js"
export * from "./StepDetails.vue?vue&type=script&lang=js"

import "./StepDetails.vue?vue&type=style&index=0&id=678f84e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678f84e0"]])

export default __exports__